

export const PostOptions = (data) => {
    return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data ? data : {}),
    credentials: 'include'
    };
}